@if (open) {
<div class="modal-backdrop fade show"></div>
<div class="modal fade show detail-modal" tabindex="-1" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        @if (isCreateMode()) {
        <h2 class="modal-title">{{ 'pages.roles.modal.create-title' | translate }}</h2>
        } @else {
        <h2 class="modal-title">{{ 'pages.roles.modal.edit-title' | translate }}</h2>
        }

        <button class="btn-close" type="button" (click)="closeDetailModal()"></button>
      </div>

      <form class="modal-body form-grid" [formGroup]="form" (ngSubmit)="save()">
        @if (!isApplicationLocked()) {
        <div class="field-block">
          <label class="form-label" for="application">{{ 'pages.roles.fields.application' | translate }}</label>
          <select class="form-select" [disabled]="saving() || deleting()" id="application"
            [value]="selectedApplicationId() ?? ''" (change)="onApplicationSelectionChange($event)">
            <option value="">{{ 'pages.roles.applications.select-placeholder' | translate }}</option>
            @for (application of filteredApplications(); track application.id ?? application.code) {
            <option [value]="application.id ?? ''">{{ application.code }} - {{ application.name }}</option>
            }
          </select>
        </div>
        }

        <div class="field-block">
          <label class="form-label" for="code">{{ 'pages.roles.fields.code' | translate }}</label>
          @if (isApplicationLocked()) {
          <div class="input-group role-code-group">
            <span class="input-group-text role-code-prefix">{{ roleCodePrefix() }}</span>
            <input
              class="form-control text-uppercase"
              [class.is-invalid]="isInvalid('codeSuffix')"
              formControlName="codeSuffix"
              id="code"
              maxlength="{{ roleCodeSuffixMaxLength() }}"
              type="text"
              (input)="onCodeSuffixInput($event)"
            />
          </div>
          <small class="form-text text-muted">{{ 'pages.roles.validation.code-prefix' | translate: { prefix: roleCodePrefix() } }}</small>
          @if (hasError('codeSuffix', 'required') && isInvalid('codeSuffix')) {
          <div class="invalid-feedback d-block">{{ 'pages.roles.validation.code-suffix-required' | translate }}</div>
          }
          @if (hasError('codeSuffix', 'maxlength') && isInvalid('codeSuffix')) {
          <div class="invalid-feedback d-block">{{ 'pages.roles.validation.code-suffix-maxlength' | translate: { max: roleCodeSuffixMaxLength() } }}</div>
          }
          } @else {
          <input
            class="form-control text-uppercase"
            [class.is-invalid]="isInvalid('code')"
            formControlName="code"
            id="code"
            maxlength="128"
            type="text"
            (input)="onCodeInput($event)"
          />
          @if (hasError('code', 'required') && isInvalid('code')) {
          <div class="invalid-feedback d-block">{{ 'pages.roles.validation.code-required' | translate }}</div>
          }
          @if (hasError('code', 'maxlength') && isInvalid('code')) {
          <div class="invalid-feedback d-block">{{ 'pages.roles.validation.code-maxlength' | translate }}</div>
          }
          }
        </div>

        <app-input-block [invalid]="isInvalid('description')" controlId="description" controlName="description"
          labelKey="pages.roles.fields.description">
          @if (hasError('description', 'required') && isInvalid('description')) {
          <div class="invalid-feedback">{{ 'pages.roles.validation.description-required' | translate }}</div>
          }
          @if (hasError('description', 'maxlength') && isInvalid('description')) {
          <div class="invalid-feedback">{{ 'pages.roles.validation.description-maxlength' | translate }}</div>
          }
        </app-input-block>

        @if (isEditMode()) {
        <app-input-block [readonly]="true" [value]="selectedCreatedAt()" controlId="created-at"
          labelKey="pages.roles.fields.created-at" />

        <app-input-block [readonly]="true" [value]="selectedUpdatedAt()" controlId="updated-at"
          labelKey="pages.roles.fields.updated-at" />
        }
      </form>

      <div class="modal-footer">
        @if (isEditMode()) {
        <button class="btn btn-light btn-danger-soft me-auto" [disabled]="saving() || deleting()" type="button"
          (click)="requestDelete()">
          <i class="fa-solid fa-trash" aria-hidden="true"></i>
          {{ 'pages.roles.actions.delete' | translate }}
        </button>
        }

        <button class="btn btn-light" [disabled]="saving() || deleting()" type="button" (click)="closeDetailModal()">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          {{ 'pages.roles.actions.cancel' | translate }}
        </button>

        <button class="btn btn-primary" [disabled]="saving() || deleting()" type="button" (click)="save()">
          <i class="fa-solid fa-floppy-disk" aria-hidden="true"></i>
          {{ 'pages.roles.actions.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
}
